/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** PayrollRunStatus */
export enum PayrollRunStatus {
  Draft = 'draft',
  Approved = 'approved',
  Cancelled = 'cancelled',
  Superseded = 'superseded',
}

/** CustomerProfileEntryKind */
export enum CustomerProfileEntryKind {
  Charge = 'charge',
  Payment = 'payment',
}

/** CaregiverPaymentType */
export enum CaregiverPaymentType {
  CostBased = 'cost_based',
  Hourly = 'hourly',
  Salary = 'salary',
}

/** BillingTransactionTypeEnum */
export enum BillingTransactionTypeEnum {
  ClientCharge = 'client_charge',
  CaregiverAccrual = 'caregiver_accrual',
  DoctorAccrual = 'doctor_accrual',
  ClientPayment = 'client_payment',
  DoctorPayout = 'doctor_payout',
  CaregiverPayout = 'caregiver_payout',
  CashCollection = 'cash_collection',
  CashDeposit = 'cash_deposit',
}

/** BillingTransactionStatusEnum */
export enum BillingTransactionStatusEnum {
  Pending = 'pending',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

/** BillingEntityTypeEnum */
export enum BillingEntityTypeEnum {
  Client = 'client',
  Caregiver = 'caregiver',
  Doctor = 'doctor',
  CaregiverCashRegister = 'caregiver_cash_register',
}

/** BalanceItem */
export interface BalanceItem {
  /** Billingaccountid */
  billingAccountId: number;
  /** Entityid */
  entityId: number;
  /** Entityname */
  entityName: string;
  /** Balance */
  balance: number;
  /** Lastmovement */
  lastMovement?: string | null;
  /** Createdat */
  createdAt?: string | null;
}

/** BalancesListResponse */
export interface BalancesListResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /** Data */
  data: BalanceItem[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** BalancesSummaryResponse */
export interface BalancesSummaryResponse {
  /** Currency */
  currency: string;
  totals: BalancesTotals;
}

/** BalancesTotals */
export interface BalancesTotals {
  /** Clients */
  clients: number;
  /** Doctors */
  doctors: number;
  /** Caregivers */
  caregivers: number;
}

/** BillingTransactionListResponse */
export interface BillingTransactionListResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /** Data */
  data: BillingTransactionResponse[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** BillingTransactionResponse */
export interface BillingTransactionResponse {
  /** Billingtransactionid */
  billingTransactionId: number;
  /** Billingaccountid */
  billingAccountId: number;
  transactionType: BillingTransactionTypeEnum;
  transactionStatus: BillingTransactionStatusEnum;
  /**
   * Transactiondate
   * @format date-time
   */
  transactionDate: string;
  /** Visitid */
  visitId?: number | null;
  /** Visitserviceid */
  visitServiceId?: number | null;
  /** Amount */
  amount: number;
  /** Currency */
  currency: string;
  /** Ratepercent */
  ratePercent?: number | null;
  /** Transactionidentifier */
  transactionIdentifier: string;
  /** Notes */
  notes?: string | null;
  /** Createdbyuserid */
  createdByUserId?: number | null;
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
  /** Updatedat */
  updatedAt?: string | null;
  /** Entityid */
  entityId?: number | null;
  /** Entitytype */
  entityType?: string | null;
  /** Entityname */
  entityName?: string | null;
  /** Clientid */
  clientId?: number | null;
  /** Clientname */
  clientName?: string | null;
}

/**
 * BillingTransactionUpdate
 * Allowed fields for patching a transaction
 */
export interface BillingTransactionUpdate {
  transactionStatus?: BillingTransactionStatusEnum | null;
  /** Transactiondate */
  transactionDate?: string | null;
  /** Amount */
  amount?: number | string | null;
  /** Ratepercent */
  ratePercent?: number | string | null;
  /** Notes */
  notes?: string | null;
}

/**
 * CaregiverCashDepositRequest
 * Request body for recording a caregiver's cash hand-back (deposit)
 */
export interface CaregiverCashDepositRequest {
  /** Amount */
  amount: number | string;
  /** Note */
  note?: string | null;
}

/**
 * CaregiverCashDepositResponse
 * Response for a caregiver cash deposit: the caregiver's new outstanding balance
 */
export interface CaregiverCashDepositResponse {
  /** Caregiverid */
  caregiverId: number;
  /** Outstandingamount */
  outstandingAmount: number;
  /**
   * Currency
   * @default "EUR"
   */
  currency?: string;
}

/** ClientWithDebt */
export interface ClientWithDebt {
  /** Key */
  key: string;
  /** Customerid */
  customerId: number;
  /** Clientname */
  clientName: string;
  /** Balance */
  balance: number;
  /** Lasttransactiondate */
  lastTransactionDate: string | null;
}

/**
 * CustomerProfileEntry
 * Unified entry for the customer profile timeline.
 * All rows come from billing_transactions, sorted by date descending.
 * Amounts are signed for display using a ledger convention:
 * incoming client payments are positive, while charges, accruals, and payouts
 * are negative.
 */
export interface CustomerProfileEntry {
  kind: CustomerProfileEntryKind;
  /** Recordid */
  recordId: number;
  /** Identifier */
  identifier?: string | null;
  /** Entityid */
  entityId: number;
  /** Entitytype */
  entityType?: string | null;
  /** Entityname */
  entityName?: string | null;
  /**
   * Date
   * @format date-time
   */
  date: string;
  /** Recordtype */
  recordType: string;
  /** Status */
  status: string;
  /**
   * Notes
   * @default ""
   */
  notes?: string;
  /** Amount */
  amount: number;
  /** Visitid */
  visitId?: number | null;
  /** Ratepercent */
  ratePercent?: number | null;
  /** Runningtotal */
  runningTotal?: number | null;
}

/** CustomerProfileResponse */
export interface CustomerProfileResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /** Data */
  data: CustomerProfileEntry[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** EntityBalanceResponse */
export interface EntityBalanceResponse {
  /** Billingaccountid */
  billingAccountId: number;
  /** Entityid */
  entityId: number;
  /** Entityname */
  entityName: string;
  /** Balance */
  balance: number;
  /** Lastmovement */
  lastMovement?: string | null;
  /** Createdat */
  createdAt?: string | null;
  entityType: BillingEntityTypeEnum;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** IncomeExpenseMonth */
export interface IncomeExpenseMonth {
  /** Key */
  key: string;
  /**
   * Month
   * @format date
   */
  month: string;
  /** Income */
  income: number;
  /** Doctors */
  doctors: number;
  /** Caregivers */
  caregivers: number;
}

/** IncomeKPIs */
export interface IncomeKPIs {
  /** Totalacquired */
  totalAcquired: number;
  /** Totalincomeinvoiced */
  totalIncomeInvoiced: number;
}

/** OverviewKPIs */
export interface OverviewKPIs {
  income: IncomeKPIs;
  /** Doctorpayables */
  doctorPayables: number;
  /** Caregiverpayables */
  caregiverPayables: number;
  /** Openclientbalances */
  openClientBalances: number;
  /** Netcashposition */
  netCashPosition: number;
}

/** OverviewSummaryResponse */
export interface OverviewSummaryResponse {
  /** Currency */
  currency: string;
  kpis: OverviewKPIs;
  /** Incomeexpenses */
  incomeExpenses: IncomeExpenseMonth[];
}

/** PartnerDebt */
export interface PartnerDebt {
  /** Key */
  key: string;
  /** Partnerid */
  partnerId: string;
  /** Partnername */
  partnerName: string;
  /** Debt */
  debt: number;
  /** Type */
  type: 'doctor' | 'caregiver';
  /** Lasttransactiondate */
  lastTransactionDate: string | null;
}

/**
 * PayrollApproveRequest
 * Body for approving a run; `override` re-approves even already-paid accruals.
 */
export interface PayrollApproveRequest {
  /**
   * Override
   * @default false
   */
  override?: boolean;
}

/** PayrollRunCreateRequest */
export interface PayrollRunCreateRequest {
  /**
   * Year
   * @min 2000
   * @max 3000
   */
  year: number;
  /**
   * Month
   * @min 1
   * @max 12
   */
  month: number;
}

/** PayrollRunItemResponse */
export interface PayrollRunItemResponse {
  /** Payrollrunitemid */
  payrollRunItemId: number;
  /** Caregiverid */
  caregiverId: number;
  /** Caregivername */
  caregiverName?: string | null;
  paymentType: CaregiverPaymentType;
  /** Hoursworked */
  hoursWorked?: number | null;
  /** Shiftcount */
  shiftCount: number;
  /** Rate */
  rate?: number | null;
  /** Amount */
  amount: number;
  /** Billingtransactionid */
  billingTransactionId?: number | null;
  /** Notes */
  notes?: string | null;
}

/** PayrollRunItemShiftResponse */
export interface PayrollRunItemShiftResponse {
  /** Payrollrunitemshiftid */
  payrollRunItemShiftId: number;
  /** Caregivershiftid */
  caregiverShiftId?: number | null;
  /**
   * Periodfrom
   * @format date-time
   */
  periodFrom: string;
  /**
   * Periodto
   * @format date-time
   */
  periodTo: string;
  /** Iswholeday */
  isWholeDay: boolean;
  /** Hours */
  hours: number;
  /** Amount */
  amount: number;
}

/** PayrollRunItemShiftsResponse */
export interface PayrollRunItemShiftsResponse {
  /** Payrollrunitemid */
  payrollRunItemId: number;
  /** Caregiverid */
  caregiverId: number;
  /** Caregivername */
  caregiverName?: string | null;
  /** Shifts */
  shifts?: PayrollRunItemShiftResponse[];
}

/** PayrollRunListResponse */
export interface PayrollRunListResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /** Data */
  data: PayrollRunResponse[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** PayrollRunResponse */
export interface PayrollRunResponse {
  /** Payrollrunid */
  payrollRunId: number;
  /** Periodyear */
  periodYear: number;
  /** Periodmonth */
  periodMonth: number;
  /**
   * Revision
   * @default 1
   */
  revision?: number;
  /** Supersedesrunid */
  supersedesRunId?: number | null;
  status: PayrollRunStatus;
  /** Totalamount */
  totalAmount: number;
  /** Currency */
  currency: string;
  /** Createdbyuserid */
  createdByUserId?: number | null;
  /** Approvedbyuserid */
  approvedByUserId?: number | null;
  /** Approvedat */
  approvedAt?: string | null;
  /** Notes */
  notes?: string | null;
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
  /** Updatedat */
  updatedAt?: string | null;
  /** Items */
  items?: PayrollRunItemResponse[];
}

/** PayrollRunStatusHistoryEntry */
export interface PayrollRunStatusHistoryEntry {
  /** Payrollrunstatushistoryid */
  payrollRunStatusHistoryId: number;
  /** Payrollrunid */
  payrollRunId: number;
  fromStatus?: PayrollRunStatus | null;
  toStatus: PayrollRunStatus;
  /** Changedbyuserid */
  changedByUserId?: number | null;
  /** Note */
  note?: string | null;
  /**
   * Changedat
   * @format date-time
   */
  changedAt: string;
}

/** PayrollRunStatusHistoryResponse */
export interface PayrollRunStatusHistoryResponse {
  /** Payrollrunid */
  payrollRunId: number;
  /** History */
  history?: PayrollRunStatusHistoryEntry[];
}

/** RecentPaymentsResponse */
export interface RecentPaymentsResponse {
  /** Clientswithdebts */
  clientsWithDebts: ClientWithDebt[];
  /** Partnersdebts */
  partnersDebts: PartnerDebt[];
  /** Clientswithdebtstotaldebt */
  clientsWithDebtsTotalDebt: number;
  /** Partnersdebtstotaldebt */
  partnersDebtsTotalDebt: number;
}

/**
 * TransactionRequestClient
 * Request body for creating a client payment transaction
 */
export interface TransactionRequestClient {
  /** Type */
  type: 'client_payment';
  /** Clientid */
  clientId: number;
  /**
   * Date
   * @format date-time
   */
  date: string;
  /** Amount */
  amount: number | string;
  /** @default "completed" */
  transactionStatus?: BillingTransactionStatusEnum;
  /**
   * Notes
   * @default ""
   */
  notes?: string | null;
}

/**
 * TransactionRequestStaff
 * Request body for creating a doctor or caregiver payout transaction
 */
export interface TransactionRequestStaff {
  /** Type */
  type: 'doctor_payout' | 'caregiver_payout';
  /** Staffid */
  staffId: number;
  /**
   * Date
   * @format date-time
   */
  date: string;
  /** Amount */
  amount: number | string;
  /** @default "completed" */
  transactionStatus?: BillingTransactionStatusEnum;
  /**
   * Notes
   * @default ""
   */
  notes?: string | null;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  JsonApi = 'application/vnd.api+json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || '/api/v1/billing-api/',
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title billing
 * @version 1.0.0
 * @baseUrl /api/v1/billing-api/
 *
 *
 * # Billing REST API
 *
 * This service manages billing accounts and payments for the Homecare platform.
 *
 * ## Features
 *
 * ### Billing Overview
 * - Get KPIs and income vs expenses summary
 * - View recent receivables and payables
 * - Track open client balances and net cash position
 *
 * ### Payments
 * - Create income payments from clients (requires completed visits)
 * - Create expense payments to staff (doctors/caregivers)
 * - View, update, and delete payment records
 * - Filter and search payments by multiple criteria
 *
 * ### Balances
 * - View balance summaries by entity type
 * - List account balances with pagination
 * - Track who owes money and who we owe
 *
 * ### Customer Profiles
 * - View complete payment history for any entity
 * - Filter by date ranges
 * - Detailed transaction records
 *
 * ## Business Rules
 *
 * - **Income Payments**: Client payments can only be recorded after visit completion
 * - **Expense Payments**: Staff payments (doctors/caregivers) are recorded immediately
 * - **Balance Updates**: Automatic balance calculations via database triggers
 * - **Payment Identifiers**: Auto-generated unique identifiers (e.g., client-101-0001)
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  health = {
    /**
     * No description
     *
     * @tags Health
     * @name GetBillingServiceHealth
     * @summary Health Check
     * @request GET:/health
     * @secure
     */
    getBillingServiceHealth: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/health`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  billing = {
    /**
     * No description
     *
     * @tags Billing Overview
     * @name GetBillingOverviewSummary
     * @summary Billing KPIs and monthly income vs expenses
     * @request GET:/billing/overview/summary
     * @secure
     */
    getBillingOverviewSummary: (
      query: {
        /**
         * Startat
         * @format date-time
         */
        startAt: string;
        /**
         * Endat
         * @format date-time
         */
        endAt: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<OverviewSummaryResponse, HTTPValidationError>({
        path: `/billing/overview/summary`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing Overview
     * @name GetBillingRecentPayments
     * @summary Clients with outstanding balances and partners we owe
     * @request GET:/billing/overview/recent-payments
     * @secure
     */
    getBillingRecentPayments: (
      query?: {
        /**
         * Limit
         * @default 5
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<RecentPaymentsResponse, HTTPValidationError>({
        path: `/billing/overview/recent-payments`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a billing transaction — actual cash movement entered by admin. **Client payment** (`type: 'client_payment'`): - `clientId`, `date`, `amount`, `method`, `transactionStatus`, `notes` **Staff payout** (`type: 'doctor_payout'` or `'caregiver_payout'`): - `staffId`, `date`, `amount`, `method`, `transactionStatus`, `notes` Transactions default to `completed`. Set `transactionStatus: pending` for pre-approved payouts not yet disbursed.
     *
     * @tags Transactions
     * @name CreateTransaction
     * @summary Record a cash payment or payout
     * @request POST:/billing/transactions
     * @secure
     */
    createTransaction: (
      data:
        | ({
            type: 'client_payment';
          } & TransactionRequestClient)
        | ({
            type: 'doctor_payout';
          } & TransactionRequestStaff)
        | ({
            type: 'caregiver_payout';
          } & TransactionRequestStaff),
      params: RequestParams = {}
    ) =>
      this.request<BillingTransactionResponse, HTTPValidationError>({
        path: `/billing/transactions`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name ListTransactions
     * @summary List transactions with filters and pagination
     * @request GET:/billing/transactions
     * @secure
     */
    listTransactions: (
      query?: {
        /** Entitytype */
        entityType?: BillingEntityTypeEnum | null;
        /** Entityid */
        entityId?: number | null;
        /** Transactiontype */
        transactionType?: string | null;
        /** Transactionstatus */
        transactionStatus?: BillingTransactionStatusEnum | null;
        /** Startdate */
        startDate?: string | null;
        /** Enddate */
        endDate?: string | null;
        /** Search */
        search?: string | null;
        /**
         * Offset
         * The records to skip
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * The max number of records to return
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<BillingTransactionListResponse, HTTPValidationError>({
        path: `/billing/transactions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name GetTransactionById
     * @summary Get Transaction By Id
     * @request GET:/billing/transactions/{transaction_id}
     * @secure
     */
    getTransactionById: (transactionId: number, params: RequestParams = {}) =>
      this.request<BillingTransactionResponse, HTTPValidationError>({
        path: `/billing/transactions/${transactionId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name UpdateTransaction
     * @summary Update Transaction
     * @request PATCH:/billing/transactions/{transaction_id}
     * @secure
     */
    updateTransaction: (transactionId: number, data: BillingTransactionUpdate, params: RequestParams = {}) =>
      this.request<BillingTransactionResponse, HTTPValidationError>({
        path: `/billing/transactions/${transactionId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name DeleteTransaction
     * @summary Delete Transaction
     * @request DELETE:/billing/transactions/{transaction_id}
     * @secure
     */
    deleteTransaction: (transactionId: number, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/billing/transactions/${transactionId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name RecordCaregiverCashDeposit
     * @summary Record a caregiver's cash hand-back (deposit)
     * @request POST:/billing/caregiver-cash/{caregiver_id}/deposit
     * @secure
     */
    recordCaregiverCashDeposit: (caregiverId: number, data: CaregiverCashDepositRequest, params: RequestParams = {}) =>
      this.request<CaregiverCashDepositResponse, HTTPValidationError>({
        path: `/billing/caregiver-cash/${caregiverId}/deposit`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Balances
     * @name GetBalancesSummary
     * @summary Total balances by entity type (derived from view)
     * @request GET:/billing/balances/summary
     * @secure
     */
    getBalancesSummary: (params: RequestParams = {}) =>
      this.request<BalancesSummaryResponse, any>({
        path: `/billing/balances/summary`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Balances
     * @name ListBalances
     * @summary Per-account balances with pagination and filtering
     * @request GET:/billing/balances
     * @secure
     */
    listBalances: (
      query?: {
        /** Type */
        type?: BillingEntityTypeEnum | null;
        /** Search */
        search?: string | null;
        /**
         * Includezero
         * Include zero-balance accounts. Defaults to false.
         * @default false
         */
        includeZero?: boolean;
        /**
         * Sort
         * JSON:API sorting, e.g. 'name,-balance'. Prefix with '-' for DESC. Fields: name, transaction, balance, created_at.
         * @default "-balance"
         */
        sort?: string | null;
        /**
         * Offset
         * The records to skip
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * The max number of records to return
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<BalancesListResponse, HTTPValidationError>({
        path: `/billing/balances`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Balances
     * @name GetEntityBalance
     * @summary Get balance for a specific entity by type and ID
     * @request GET:/billing/balances/{entity_type}/{entity_id}
     * @secure
     */
    getEntityBalance: (entityType: BillingEntityTypeEnum, entityId: number, params: RequestParams = {}) =>
      this.request<EntityBalanceResponse, HTTPValidationError>({
        path: `/billing/balances/${entityType}/${entityId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a sorted list of all billing transactions (charges and payments) for the given entity, newest first. Each entry has a `kind` field: `'charge'` or `'payment'`.
     *
     * @tags Customer Profile
     * @name GetCustomerProfile
     * @summary Unified billing timeline for a client, doctor or caregiver
     * @request GET:/billing/customer-profile
     * @secure
     */
    getCustomerProfile: (
      query?: {
        /** Entitytype */
        entityType?: BillingEntityTypeEnum | null;
        /** Entityid */
        entityId?: number | null;
        /** Startat */
        startAt?: string | null;
        /** Endat */
        endAt?: string | null;
        /**
         * Paymenttype
         * Filter by transaction_type (e.g. client_charge, client_payment)
         */
        paymentType?: string | null;
        /**
         * Offset
         * The records to skip
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * The max number of records to return
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<CustomerProfileResponse, HTTPValidationError>({
        path: `/billing/customer-profile`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Initiate a background CSV export of the unified billing timeline using the same filters as GET /billing/customer-profile. Returns 201 immediately; a push notification is sent when the file is ready.
     *
     * @tags Customer Profile
     * @name ExportCustomerProfile
     * @summary Export customer profile data
     * @request POST:/billing/customer-profile/export
     * @secure
     */
    exportCustomerProfile: (
      query?: {
        /** Entitytype */
        entityType?: BillingEntityTypeEnum | null;
        /** Entityid */
        entityId?: number | null;
        /** Startat */
        startAt?: string | null;
        /** Endat */
        endAt?: string | null;
        /**
         * Paymenttype
         * Filter by transaction_type
         */
        paymentType?: string | null;
        /**
         * Extracolumns
         * Additional column names to append to the standard CSV columns
         */
        extraColumns?: string[] | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<any, HTTPValidationError | void>({
        path: `/billing/customer-profile/export`,
        method: 'POST',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Download a previously generated customer profile export file by path.
     *
     * @tags Customer Profile
     * @name DownloadCustomerProfileExport
     * @summary Download exported customer profile CSV file
     * @request GET:/billing/customer-profile/export/download
     * @secure
     */
    downloadCustomerProfileExport: (
      query: {
        /**
         * File Path
         * Full path of the exported CSV file
         */
        file_path: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<any, void | HTTPValidationError>({
        path: `/billing/customer-profile/export/download`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  payroll = {
    /**
     * No description
     *
     * @tags Payroll
     * @name CreatePayrollRun
     * @summary Create or recompute a draft payroll run for a month
     * @request POST:/payroll/runs
     * @secure
     */
    createPayrollRun: (data: PayrollRunCreateRequest, params: RequestParams = {}) =>
      this.request<PayrollRunResponse, HTTPValidationError>({
        path: `/payroll/runs`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payroll
     * @name ListPayrollRuns
     * @summary List payroll runs
     * @request GET:/payroll/runs
     * @secure
     */
    listPayrollRuns: (
      query?: {
        /**
         * Sort
         * JSON:API sorting, e.g. '-created_at'. Prefix with '-' for DESC.
         */
        sort?: string | null;
        /**
         * Offset
         * The records to skip
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * The max number of records to return
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<PayrollRunListResponse, HTTPValidationError>({
        path: `/payroll/runs`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payroll
     * @name GetPayrollRun
     * @summary Get a payroll run with its per-caregiver line items (summary view)
     * @request GET:/payroll/runs/{payroll_run_id}
     * @secure
     */
    getPayrollRun: (payrollRunId: number, params: RequestParams = {}) =>
      this.request<PayrollRunResponse, HTTPValidationError>({
        path: `/payroll/runs/${payrollRunId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payroll
     * @name ApprovePayrollRun
     * @summary Approve a draft run — post caregiver accruals
     * @request POST:/payroll/runs/{payroll_run_id}/approve
     * @secure
     */
    approvePayrollRun: (payrollRunId: number, data: PayrollApproveRequest | null, params: RequestParams = {}) =>
      this.request<PayrollRunResponse, HTTPValidationError>({
        path: `/payroll/runs/${payrollRunId}/approve`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payroll
     * @name CancelPayrollRun
     * @summary Cancel a draft payroll run
     * @request POST:/payroll/runs/{payroll_run_id}/cancel
     * @secure
     */
    cancelPayrollRun: (payrollRunId: number, params: RequestParams = {}) =>
      this.request<PayrollRunResponse, HTTPValidationError>({
        path: `/payroll/runs/${payrollRunId}/cancel`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payroll
     * @name RevisePayrollRun
     * @summary Create a correction (new revision) of an approved run
     * @request POST:/payroll/runs/{payroll_run_id}/revise
     * @secure
     */
    revisePayrollRun: (payrollRunId: number, params: RequestParams = {}) =>
      this.request<PayrollRunResponse, HTTPValidationError>({
        path: `/payroll/runs/${payrollRunId}/revise`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payroll
     * @name GetPayrollItemShifts
     * @summary Get a caregiver's per-shift breakdown for a run (price per shift)
     * @request GET:/payroll/runs/{payroll_run_id}/items/{item_id}/shifts
     * @secure
     */
    getPayrollItemShifts: (payrollRunId: number, itemId: number, params: RequestParams = {}) =>
      this.request<PayrollRunItemShiftsResponse, HTTPValidationError>({
        path: `/payroll/runs/${payrollRunId}/items/${itemId}/shifts`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payroll
     * @name GetPayrollRunHistory
     * @summary Get the status-change history (who/when) for a run
     * @request GET:/payroll/runs/{payroll_run_id}/history
     * @secure
     */
    getPayrollRunHistory: (payrollRunId: number, params: RequestParams = {}) =>
      this.request<PayrollRunStatusHistoryResponse, HTTPValidationError>({
        path: `/payroll/runs/${payrollRunId}/history`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
}
